import registroStore from "./registro-store";
import datosStore from "./datos-store";

export default {
  datos: datosStore,
  registros: registroStore
};
